import React from "react"

export default function Chat() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
         <g clipPath="url(#clip0_91_12909)">
            <path d="M9 3.09375C5.27168 3.09375 2.25 5.54854 2.25 8.57812C2.25 9.88594 2.81426 11.083 3.75293 12.0243C3.42334 13.3532 2.32119 14.5371 2.30801 14.5503C2.25 14.6109 2.23418 14.7006 2.26846 14.7797C2.30273 14.8588 2.37656 14.9062 2.46094 14.9062C4.20908 14.9062 5.51953 14.0678 6.16816 13.551C7.03037 13.8753 7.9875 14.0625 9 14.0625C12.7283 14.0625 15.75 11.6077 15.75 8.57812C15.75 5.54854 12.7283 3.09375 9 3.09375Z" fill="white" />
         </g>
         <defs>
            <clipPath id="clip0_91_12909">
               <rect width="13.5" height="13.5" fill="white" transform="translate(2.25 2.25)" />
            </clipPath>
         </defs>
      </svg>
   )
}